
import {
    createFileRoute,
    useNavigate,
} from '@tanstack/react-router'

import {
    ResetPasswordForm,
} from '@/features/authentication/components/ResetPasswordForm'

export const Route = createFileRoute(
    '/authentication/reset-password',
)({
    validateSearch: (search: Record<string, unknown>) => ({
        userName:
            typeof search.userName === 'string'
                ? search.userName
                : '',
        token:
            typeof search.token === 'string'
                ? search.token
                : '',
    }),

    component: function ResetPasswordPage() {
        const navigate = useNavigate()

        const { userName, token } = Route.useSearch()

        function handleBackToLogin(): void {
            void navigate({
                to: '/authentication/login',
            })
        }

        return (
            <div className="flex min-h-screen items-center justify-center bg-(--color-surface) px-4">
                <ResetPasswordForm
                    onBackToLogin={handleBackToLogin}
                    userName={userName}
                    token={token}
                />
            </div>
        )
    },
})
